import { render, staticRenderFns } from "./config_about.vue?vue&type=template&id=63a7317d&"
import script from "./config_about.vue?vue&type=script&lang=js&"
export * from "./config_about.vue?vue&type=script&lang=js&"
import style0 from "./config_about.vue?vue&type=style&index=0&id=63a7317d&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports